<div class="row justify-content-center bg-body m-0">
  <div class="col-lg-6 col-12">
    <div class="card my-4">
      <div class="row" id="htmlContent">
        <div class="col-lg-12">
          <div class="card-body p-4">
            <div class="row g-3">
              <div class="col-6">
                <p class="text-muted mb-2 text-uppercase fw-semibold">{{ "label-title.booking-id" | translate }}</p>
                <h5 class="fs-14 mb-0">{{ bookingDetails.uniqueId }}</h5>
              </div>
              <div class="col-6">
                <p class="text-muted mb-2 text-uppercase fw-semibold">{{ "label-title.created-date" | translate }}</p>
                <h5 class="fs-14 mb-0">
                  <span id="invoice-date">{{
                    helper.moment(bookingDetails.createdAt).tz(bookingTimezone).format(helper.DATE_FORMAT.MOMENT_DD_MMM_COMA_YYYY)
                    }} </span>
                  <small class="text-muted" id="invoice-time">{{
                    helper.moment(bookingDetails.createdAt).tz(bookingTimezone).format(bookingDetails.timeFormat ?? helper.TimeFormatEnum.TwentyFourHour) }}
                  </small>
                </h5>
              </div>
              @if(bookingHistoryMainType !== helper.BookingHistoryMainType.SCHEDULED){
              <div class="col-6">
                <p class="text-muted mb-2 text-uppercase fw-semibold">{{ "label-title.booking-date" | translate }}</p>
                <h5 class="fs-14 mb-0">
                  <span id="invoice-date">{{
                    helper.moment(bookingDetails.bookingTime).tz(bookingTimezone).format(helper.DATE_FORMAT.MOMENT_DD_MMM_COMA_YYYY)
                    }} </span>
                  <small class="text-muted" id="invoice-time">{{
                    helper.moment(bookingDetails.bookingTime).tz(bookingTimezone).format(bookingDetails.timeFormat ?? helper.TimeFormatEnum.TwentyFourHour) }}
                  </small>
                </h5>
              </div>
              } @if(bookingHistoryMainType === helper.BookingHistoryMainType.SCHEDULED){
              <div class="col-6">
                <p class="text-muted mb-2 text-uppercase fw-semibold">{{ "label-title.schedule-date" | translate }}</p>
                <h5 class="fs-14 mb-0">
                  <span id="invoice-date">{{
                    helper.moment(bookingDetails.bookingTime).tz(bookingTimezone).format(helper.DATE_FORMAT.MOMENT_DD_MMM_COMA_YYYY)
                    }} </span>
                  <small class="text-muted" id="invoice-time">{{
                    helper.moment(bookingDetails.bookingTime).tz(bookingTimezone).format(bookingDetails.timeFormat ?? helper.TimeFormatEnum.TwentyFourHour) }}
                  </small>
                </h5>
              </div>
              } @if(bookingDetails.completedAt && invoiceType === 'actual'){
              <div class="col-6">
                <p class="text-muted mb-2 text-uppercase fw-semibold">{{ "label-title.completed-date" | translate }}</p>
                <h5 class="fs-14 mb-0">
                  <span id="invoice-date">{{
                    helper.moment(bookingDetails.completedAt).tz(bookingTimezone).format(helper.DATE_FORMAT.MOMENT_DD_MMM_COMA_YYYY)
                    }} </span>
                  <small class="text-muted" id="invoice-time">{{
                    helper.moment(bookingDetails.completedAt).tz(bookingTimezone).format(bookingDetails.timeFormat ?? helper.TimeFormatEnum.TwentyFourHour) }}
                  </small>
                </h5>
              </div>
              } @if (paymentStatus) {
              <div class="col-6">
                <p class="text-muted mb-2 text-uppercase fw-semibold">{{ "label-title.payment-status" | translate }}</p>
                <span id="payment-status" class="badge bg-primary fs-11" [ngClass]="{
                    'bg-warning-subtle text-warning':
                      paymentStatus === helper.PaymentTransactionStatus.PENDING || paymentStatus === helper.PaymentTransactionStatus.CAPTURE_REQUIRED,
                    'bg-info-subtle text-info': paymentStatus === helper.PaymentTransactionStatus.INITIATED,
                    'bg-success-subtle text-success': paymentStatus === helper.PaymentTransactionStatus.PAID,
                    'bg-primary-subtle text-primary': paymentStatus === helper.PaymentTransactionStatus.PAY_LATER,
                    'bg-danger-subtle text-danger': paymentStatus === helper.PaymentTransactionStatus.FAILED || paymentStatus === helper.PaymentTransactionStatus.CANCELLED
                  }">{{ helper.PaymentTransactionStatusString[paymentStatus] | translate }}
                </span>
              </div>
              }
              <div class="col-6">
                <p class="text-muted mb-2 text-uppercase fw-semibold">{{ "label-title.distance" | translate }}</p>
                <h5 class="fs-14 mb-0">{{ (bookingInvoiceDetails?.distance *
                  distanceConversionValue).toFixed(decimalPointValue) }} {{ distanceUnitString | translate }}</h5>
              </div>
              <div class="col-6">
                <p class="text-muted mb-2 text-uppercase fw-semibold">{{ "label-title.time" | translate }}</p>
                <h5 class="fs-14 mb-0">{{ helper.formatTime(bookingInvoiceDetails?.time) }}</h5>
              </div>
              @if (bookingHistoryMainType === helper.BookingHistoryMainType.RUNNING || invoiceType === 'actual') {
              <div class="col-6">
                @if (invoiceType === 'estimated') {
                <p class="text-muted mb-2 text-uppercase fw-semibold">{{ "label-title.free-wait-time" | translate }} ({{
                  "label-title.pickup" | translate }})</p>
                } @else {
                <p class="text-muted mb-2 text-uppercase fw-semibold">{{ "label-title.wait-time" | translate }} ({{
                  "label-title.pickup" | translate }})</p>
                }
                <h5 class="fs-14 mb-0">
                  {{ helper.formatTime(bookingInvoiceDetails?.waitingTime) }}
                  @if (estimatedBookingInvoiceDetails?.waitingTime && invoiceType === 'actual') { ({{ "label-title.free"
                  | translate }}
                  {{ helper.formatTime(estimatedBookingInvoiceDetails?.waitingTime) }}) }
                </h5>
              </div>
              <!-- show if not rental booking start -->
              @if(isNotRentalBooking() && isNotQuickCommerceBooking()) {
              <div class="col-6">
                @if (invoiceType === 'estimated') {
                <p class="text-muted mb-2 text-uppercase fw-semibold">{{ "label-title.free-stand-by-time" | translate }}
                </p>
                } @else {
                <p class="text-muted mb-2 text-uppercase fw-semibold">{{ "label-title.stand-by-time" | translate }}</p>
                }
                <h5 class="fs-14 mb-0">
                  {{ helper.formatTime(bookingInvoiceDetails?.stopWaitingTime) }}
                  @if (estimatedBookingInvoiceDetails?.stopWaitingTime && invoiceType === 'actual') { ({{
                  "label-title.free" | translate }}
                  {{ helper.formatTime(estimatedBookingInvoiceDetails?.stopWaitingTime) }}) }
                </h5>
              </div>
              }
              <!-- show if not rental and quick commerce booking end -->
              <!-- show if not rental booking start -->
              @if (isNotRentalBooking()) {
              <div class="col-6">
                @if (invoiceType === 'estimated') {
                <p class="text-muted mb-2 text-uppercase fw-semibold">{{ "label-title.free-traffic-time" | translate }}
                </p>
                } @else {
                <p class="text-muted mb-2 text-uppercase fw-semibold">{{ "label-title.traffic-time" | translate }}</p>
                }
                <h5 class="fs-14 mb-0">
                  {{ helper.formatTime(bookingInvoiceDetails?.trafficTime) }}
                  @if (estimatedBookingInvoiceDetails?.trafficTime && invoiceType === 'actual') { ({{ "label-title.free"
                  | translate }}
                  {{ helper.formatTime(estimatedBookingInvoiceDetails?.trafficTime) }}) }
                </h5>
              </div>
              }
              <!-- show if not rental booking end -->
              }
            </div>
          </div>
        </div>

        <div class="col-lg-12">
          <div class="card-body p-4 border-top border-top-dashed">
            <div class="row g-3">
              <div class="col-6">
                <h6 class="text-muted text-uppercase fw-semibold mb-3">{{ "heading-title.pickup-address" | translate }}
                </h6>
                <p class="text-muted mb-1">{{ bookingDetails.pickupAddress?.address }}</p>
                @if(bookingDetails.pickupAddress?.metadata?.length){
                <div class="d-flex flex-column">
                  @for (item of bookingDetails.pickupAddress?.metadata; track item.key) {
                  <small class="text-muted"><b>{{ item.key }}:</b> {{ item.value }}</small>
                  }
                </div>
                }
              </div>
              @if (bookingDetails.actualDestinationAddresses?.length > 0 && bookingDetails.status >=
              helper.BookingStatus.ARRIVED_AT_DESTINATION && bookingDetails.status !=
              helper.BookingStatus.CANCELLED && invoiceType === 'actual') {
              <div class="col-6">
                <h6 class="text-muted text-uppercase fw-semibold mb-3">{{ "heading-title.destination-address" |
                  translate }}</h6>
                <p class="text-muted mb-1">{{
                  bookingDetails.actualDestinationAddresses[bookingDetails.actualDestinationAddresses.length -
                  1]?.address }}</p>
                @if(bookingDetails.actualDestinationAddresses[bookingDetails.actualDestinationAddresses.length - 1]?.metadata?.length){
                <div class="d-flex flex-column">
                  @for (item of bookingDetails.actualDestinationAddresses[bookingDetails.actualDestinationAddresses.length -
                  1]?.metadata; track item.key) {
                  <small class="text-muted"><b>{{ item.key }}:</b> {{ item.value }}</small>
                  }
                </div>
                }
              </div>
              } @else if(bookingDetails.destinationAddresses?.length > 0){
              <div class="col-6">
                <h6 class="text-muted text-uppercase fw-semibold mb-3">{{ "heading-title.destination-address" |
                  translate }}</h6>
                <p class="text-muted mb-1">{{
                  bookingDetails.destinationAddresses[bookingDetails.destinationAddresses.length - 1]?.address }}</p>
                @if(bookingDetails.destinationAddresses[bookingDetails.destinationAddresses.length - 1]?.metadata?.length){
                <div class="d-flex flex-column">
                  @for (item of bookingDetails.destinationAddresses[bookingDetails.destinationAddresses.length - 1]?.metadata; track
                  item.key) {
                  <small class="text-muted">
                    <b>{{ item.key }}:</b> {{ item.value }}
                  </small>
                  }
                </div>
                }
              </div>
              }
            </div>
          </div>
        </div>

        <div class="col-lg-12">
          <div class="card-body p-4">
            @if (bookingInvoiceDetails?.total > 0) {
            <div class="table-responsive">
              <table class="table table-borderless text-center table-nowrap align-middle mb-0"
                aria-describedby="booking-details-table">
                <thead>
                  <tr class="">
                    <th scope="col" class="text-start">{{ "label-title.booking-details" | translate }}</th>
                    <th scope="col" class="text-end">{{ "label-title.amount" | translate }}</th>
                  </tr>
                </thead>
                <tbody id="products-list">
                  @for (element of arrInvoiceElement; track $index) {
                  <tr class="border-top border-top-dashed">
                    <td class="text-start">
                      <span class="fw-medium">{{ element.strTitle | translate }}</span>
                      @for (item of element.strSubTitleArray; track $index) { @if (item.title) {
                      <p class="text-muted mb-0">{{ item.title }}</p>
                      } }
                    </td>
                    <td class="text-end">
                      <span class="fw-medium">{{ element.strAmount }}</span>
                      @for (item of element.strSubTitleArray; track $index) { @if (item.value){
                      <p class="text-muted mb-0">{{ item.value }}</p>
                      }@else {
                      <p></p>
                      } }
                    </td>
                  </tr>
                  } @if (bookingInvoiceDetails?.taxPrices?.length > 0 && totalTax > 0) {
                  <tr class="border-top border-top-dashed">
                    <td class="text-start">
                      <span class="fw-medium">{{ "label-title.total-tax" | translate | titlecase }}</span>
                      @for (tax of bookingInvoiceDetails?.taxPrices; track $index) { @if(tax.unit > 0){
                      <p class="text-muted mb-0">{{ tax.title }} ({{ tax.unit?.toFixed(decimalPointValue) }}%)</p>
                      } }
                    </td>
                    <td class="text-end">
                      <span class="fw-medium">
                        <span class="d-flex currency-gap justify-content-end">
                          {{ totalTax.toFixed(decimalPointValue) }}
                          <span [ngClass]="{ 'order-first': setCurrencySign == helper.SetCurrencySignUnit.LEFT }">
                            {{ currencySign }}
                          </span>
                        </span>
                      </span>
                      @for (tax of bookingInvoiceDetails?.taxPrices; track $index) {
                      <p class="text-muted mb-0">{{ tax.price?.toFixed(decimalPointValue) }}</p>
                      }
                    </td>
                  </tr>
                  }@if (isMinfareApplied()) {
                  <tr>
                    <td>
                      <p class="text-danger text-start mb-0">*{{ "label-title.minimum-fare-applied" | translate }}</p>
                    </td>
                  </tr>
                  } @if (bookingInvoiceDetails?.pickupIncentive?.amount > 0) {
                  <tr>
                    <td class="text-start">
                      <span class="fw-medium">Long-pickup incentive</span>
                      <p class="text-muted mb-0">Platform pays the driver. Not added to the rider or tow fare.</p>
                    </td>
                    <td class="text-end">
                      <span class="d-flex currency-gap justify-content-end">
                        {{ bookingInvoiceDetails.pickupIncentive.amount.toFixed(decimalPointValue) }}
                        <span [ngClass]="{ 'order-first': setCurrencySign == helper.SetCurrencySignUnit.LEFT }">
                          {{ currencySign }}
                        </span>
                      </span>
                      <p class="text-muted mb-0">Not on the fare</p>
                    </td>
                  </tr>
                  }
                  <tr class="border-top border-top-dashed fs-15">
                    <th scope="row" class="text-start">{{ "label-title.total-amount" | translate }}</th>
                    <th class="text-end" id="booking-total-amount">
                      <span class="d-flex currency-gap justify-content-end">
                        {{ bookingInvoiceDetails?.total?.toFixed(decimalPointValue) }}
                        <span [ngClass]="{ 'order-first': setCurrencySign == helper.SetCurrencySignUnit.LEFT }">
                          {{ currencySign }}
                        </span>
                      </span>
                    </th>
                  </tr>
                </tbody>
              </table>
            </div>
            }
            <div class="mt-3">
              <h6 class="text-muted text-uppercase fw-semibold mb-3">{{ "label-title.payment-details" | translate }}:
              </h6>
              <p class="text-muted mb-1">
                {{ "label-title.payment-method" | translate }}: <span class="fw-medium" id="payment-method">{{
                  paymentModeString | translate }}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="card-body">
            <div class="hstack gap-2 justify-content-end d-print-none">
              <a href="javascript:void(0);" id="download-invoice" class="btn btn-secondary btn-load"
                (click)="downloadPdf()" [ngClass]="{ 'pointer-events-none': helper.showBtnLoader[1] }">
                <span class="d-flex align-items-center">
                  @if (helper.showBtnLoader[1]) {
                  <span class="spinner-border flex-shrink-0">
                    <span class="visually-hidden"></span>
                  </span>
                  } @else {
                  <span class="flex-grow-1" [ngClass]="{ 'ms-2': helper.showBtnLoader[1] }">
                    <em class="ri-download-2-line align-bottom me-1"></em> {{ "button-title.download" | translate }}
                  </span>
                  }
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>